import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const parallackCircles = document.querySelectorAll(".parallax-circle");

if (reduceMotion === false && parallackCircles) {
  gsap.to(".parallax-circle", {
    scrollTrigger: {
      trigger: "#servicesTop",
      start: "-82px",
      end: "bottom top",
      scrub: true
    },
    y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
    ease: "none"
  });
} else {
  return;
}
